<template>
    <div id="app">
        <div v-if="(license_key && current_scope) || build_env != 'electron'">
            <router-view class="app-container"></router-view>
            <ImagePrinter></ImagePrinter>
            <DocumentPrinter
                :width="document_printer_options.width"
                :documents="document_printer_options.documents"
                :paper_type="document_printer_options.paper_type"
                :numbers_of_one_page="document_printer_options.numbers_of_one_page">
            </DocumentPrinter>
        </div>
        <div v-else>
            <div v-if="!current_scope">
                <h1 class="setup_header">請選擇介面：</h1>
                <div class="scope_selector">
                    <a href="#" class="scope_selection" @click.prevent="set_current_scope('station')">外站</a>
                    <a href="#" class="scope_selection" @click.prevent="set_current_scope('customer')">客戶</a>
                    <a href="#" class="scope_selection" @click.prevent="set_current_scope('provider')">系統</a>
                </div>
            </div>
            <div v-else>
                <h1 class="setup_header">請輸入您的LMS授權碼：</h1>
                <div class="license_key_container">
                    <input type="text" class="license_key_input" v-model="new_license_key" @keypress.enter="set_license_key()">
                    <a href="#" class="license_key_submit" @click.prevent="set_license_key()">送出</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImagePrinter from '@toolbox/printers/image_printer.vue'
import DocumentPrinter from '@toolbox/printers/document_printer.vue'

export default {
    data() {
        return {
            image_printer_options: {
                width: 210,
                images: [],
                paper_type: "A4",
                numbers_of_one_page: 6
            },
            document_printer_options: {
                width: 210,
                documents: [],
                paper_type: "A4",
                numbers_of_one_page: 6
            },
            license_key_websock_server: null,
            current_scope_websock_server: null,
            new_license_key: "",
            license_key: window.LICENSE_KEY,
            current_scope: window.CURRENT_SCOPE,
        }
    },
    computed: {
        build_env() {
            return ENV.VUE_APP_BUILD_ENV
        }
    },
    mounted() {
        if (this.build_env == 'electron') {
            this.current_scope_websock_server = new WebSocket('ws://127.0.0.1:8899/current_scope')
            this.current_scope_websock_server.onmessage = (messgae) => {
                this.current_scope = messgae
                return false
            }
            this.current_scope_websock_server.onclose = () => {
                console.log("WebSocket on current_scope disconnect")
            }
            this.current_scope_websock_server.onopen = () => {
                console.log("WebSocket on current_scope opened")
            }
            this.current_scope_websock_server.onerror = (error) => {
                console.log("WebSocket on current_scope error")
            }

            this.license_key_websock_server = new WebSocket('ws://127.0.0.1:8899/license_key')
            this.license_key_websock_server.onmessage = (messgae) => {
                this.license_key = messgae
                return false
            }
            this.license_key_websock_server.onclose = () => {
                console.log("WebSocket on license_key disconnect")
            }
            this.license_key_websock_server.onopen = () => {
                console.log("WebSocket on license_key opened")
            }
            this.license_key_websock_server.onerror = (error) => {
                console.log("WebSocket on license_key error")
            }
        }
        this.$bus.$off("out_of_date")
        this.$bus.$on("out_of_date", (exclude_instance, scope) => {
            axios.get(this.$store.state.settings.out_of_date_url + "?exclude_instance=" + exclude_instance + '&scope=' + scope)
        })
    },
    watch: {
    },
    methods: {
        set_current_scope(new_current_scope) {
            if (new_current_scope) {
                this.current_scope_websock_server.send(new_current_scope)
            }
        },
        set_license_key() {
            if (this.new_license_key) {
                localStorage.setItem("electron_cache_identity", this.new_license_key)
                this.license_key_websock_server.send(this.new_license_key)
            }
        },
    },
    components: {
        ImagePrinter,
        DocumentPrinter
    },
}
</script>

<style lang="scss">
.setup_header {
    padding: 5px;
}
.scope_selector {
    text-align: center;
}
.scope_selection {
    text-align: center;
    border-radius: 3px;
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    color: white;
    background: #ffbd45;
    line-height: 80px;
    margin: 10px 20px;
    width: 80px;
    height: 80px;
    border: 1px solid #ecb333;
    transition: all 0.5s;
    -webkit-box-shadow: 0 8px 17px 2px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.2);
    box-shadow: 0 8px 17px 2px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.2);
}
.scope_selection:hover {
    color: white;
    -webkit-box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
}
.license_key_container {
    position: relative;
    text-align: center;
    height: 100px;
}
.license_key_input {
    width: 90%;
    font-weight: bold;
    font-size: 18px;
    padding: 5px;
    margin: 0 auto;
    border: none;
    border-bottom: 2px solid black;
    margin: 10px;
}
.license_key_input:focus {
    outline: none;
}
.license_key_submit {
    border: 2px solid;
    font-weight: bold;
    padding: 10px 20px;
    position: absolute;
    right: 5%;
    bottom: 5%;
    display: inline-block;
}
</style>
